import { Box, Typography, Link, Divider } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("footer");
  const year = new Date(Date.now()).getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#0B0B0B",
        color: "#FFFFFF",
        px: { xs: 3, md: 8 },
        py: { xs: 6, md: 8 },
      }}
    >
      <Box
        sx={{
          maxWidth: 1400,
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          gap: { xs: 4, md: 6 },
        }}
      >
        {/* Brand / Legal */}
        <Box>
          <Typography
            sx={{
              fontFamily: "Playfair Display",
              fontSize: "1.1rem",
              letterSpacing: "0.25em",
              mb: 1.5,
            }}
          >
            {t("brand")}
          </Typography>

          <Typography
            sx={{
              fontSize: "0.75rem",
              lineHeight: 1.7,
              opacity: 0.7,
              maxWidth: 320,
            }}
          >
            {t("caLicense")}
          </Typography>
        </Box>

        {/* Links (routes fixed) */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.2,
          }}
        >
          <FooterLink to="/privacy-policy">
            {t("links.privacy.label")}
          </FooterLink>

          <FooterLink to="/terms">{t("links.terms.label")}</FooterLink>
        </Box>
      </Box>

      {/* Divider */}
      <Divider
        sx={{
          my: { xs: 4, md: 5 },
          borderColor: "rgba(255,255,255,0.1)",
        }}
      />

      {/* Bottom Row */}
      <Box
        sx={{
          maxWidth: 1400,
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: "0.7rem",
            letterSpacing: "0.12em",
            opacity: 0.6,
          }}
        >
          © {year} {t("copyright")}
        </Typography>
      </Box>
    </Box>
  );
}

/* Helper component for consistent links */
function FooterLink({ to, children }) {
  return (
    <Link
      component={NavLink}
      to={to}
      underline="none"
      sx={{
        fontSize: "0.75rem",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        color: "#FFFFFF",
        opacity: 0.75,
        transition: "opacity 0.3s ease",
        "&:hover": {
          opacity: 1,
        },
      }}
    >
      {children}
    </Link>
  );
}
